import React from 'react';
import baseStyles from '../ScoreRules/ScoreRules.module.css';
import styles from './NtrpScale.module.css';

const LEVELS = [
    {
        id: 'ntrp-1-0',
        level: '1.0',
        description: 'Gracz dopiero zaczyna swoją przygodę z tenisem.',
    },
    {
        id: 'ntrp-1-5',
        level: '1.5',
        description: 'Gracz ma małe doświadczenie w uderzaniu piłek oraz ciągle pracuje nad utrzymaniem piłki w grze niezależnie od ich tempa. Serwis sprawia mu trudność. Ten gracz nie jest jeszcze gotowy do rywalizacji.',
    },
    {
        id: 'ntrp-2-0',
        level: '2.0',
        description: 'Graczowi brakuje doświadczenia kortowego (ogrania). Ma widoczne braki w technice, ale rozumie podstawy gry singlowej i deblowej.',
    },
    {
        id: 'ntrp-2-5',
        level: '2.5',
        description: 'Gracz uczy się oceniać miejsce uderzenia piłki w kort przy jej odbiorze, jednak poruszanie się po korcie wymaga dalszej pracy. Potrafi utrzymać wolne wymiany piłek i zaczyna pokrywać cały kort. Gotowy jest do rywalizacji w meczach i podstawowych turniejach.',
        strengths: null,
        weaknesses: 'Brak odpowiedniego trzymania rakiety, niepełny zamach przy serwisie, niespójne podrzucenie piłki do serwisu, ograniczona gra przy siatce.',
    },
    {
        id: 'ntrp-3-0',
        level: '3.0',
        description: 'Ten gracz jest już dość konsekwentny przy uderzaniu średnio szybkich piłek, ale nie czuje się komfortowo z wszystkimi uderzeniami i brakuje mu precyzji przy próbie kontroli kierunku, głębokości, tempa lub zmiany dystansu uderzeń. Najczęstsza formacja w deblu to jeden z przodu, jeden z tyłu (w deblu staramy się dążyć do uzyskania i utrzymania linii równoległej do siatki).',
        strengths: null,
        weaknesses: 'Trudności z tempem uderzeń, może czuć się niekomfortowo przy siatce.',
    },
    {
        id: 'ntrp-3-5',
        level: '3.5',
        description: 'Gracz poprawił niezawodność i kontrolę kierunku uderzeń przy średnim tempie piłek, ale brakuje mu różnorodności w uderzeniach. Takie zagrania jak efektywne wykorzystanie loba, uderzenia znad głowy, gra przy siatce oraz wolej są ograniczone ze względu na brak pewności. Gracz poprawił grę przy siatce oraz krycie kortu.',
        strengths: 'Gracz na tym poziomie wykorzystuje umiejętność skupienia się, taktyki i strategii gry.',
        weaknesses: null,
    },
    {
        id: 'ntrp-4-0',
        level: '4.0',
        description: 'Gracz ma pewne uderzenia włączając w to kontrolę kierunku zagrania, głębokości i umiejętność zmiany odległości uderzeń zarówno przy uderzeniach forehandowych jak i backhandowych podczas gry w średnim tempie. Z sukcesem wykorzystuje loby, uderzenia znad głowy, grę przy siatce i woleje. Gracz rzadko popełnia błędy serwisowe.',
        strengths: 'Niezawodny drugi serwis, wykorzystuje swoje atuty do zdobycia punktu.',
        weaknesses: 'Może przegrywać wymiany przez brak dostatecznego skupienia.',
    },
    {
        id: 'ntrp-4-5',
        level: '4.5',
        description: 'Gracz zaczyna świadomie zmieniać tempo i rotację piłki, dobrze porusza się po korcie, potrafi kontrolować odległość i głębokość uderzeń, zaczyna planować grę na podstawie mocnych i słabych stron. Pierwszy serwis jest mocny i celny, nie popełnia błędów przy drugim serwisie.',
        strengths: 'O wyniku coraz częściej decyduje serwis, potrafi niwelować swoje słabości poprzez kreowanie gry.',
        weaknesses: 'Przy trudnych piłkach ma jeszcze tendencję do grania w aut.',
    },
    {
        id: 'ntrp-5-0',
        level: '5.0',
        description: 'Gracz ma zdolność do przewidywania uderzeń przeciwnika, często potrafi grać mocnymi uderzeniami, na czym opiera swoją grę. Potrafi regularnie uderzać zwycięskie piłki lub wymuszać błąd u przeciwnika za pomocą gry skrótami, wolejami, lobami, półwolejami, uderzeniami znad głowy. Pewny pierwszy serwis oraz rotacja piłki przy drugim serwisie.',
        strengths: 'Dobra decyzyjność, ukrywa swoje słabości, silny psychicznie.',
        weaknesses: 'Może popełniać błędy w trudnych sytuacjach.',
    },
    {
        id: 'ntrp-5-5',
        level: '5.5',
        description: 'Gracz rozwinął niezawodność i siłę uderzeń jako główną broń. Potrafi zmieniać strategię i styl gry w wymagających tego sytuacjach oraz ma niezawodne uderzenia grając pod presją.',
        strengths: 'Potrafi grać ofensywnie w każdej sytuacji, zmienia strategie i styl gry w trudnych sytuacjach. Pomimo presji pierwszy i drugi serwis jest niezawodny.',
        weaknesses: null,
    },
];

const NtrpScale = () => {
    return (
        <div className={baseStyles.scoreRulesContainer}>
            <h1>Skala NTRP</h1>

            <p className={baseStyles.preliminaryDescription}>
                Skala NTRP (National Tennis Rating Program) jest wskaźnikiem poziomu umiejętności czysto tenisowych
                (techniczno-taktycznych). Została stworzona przez Federację Tenisową Stanów Zjednoczonych (USTA) w 1979 roku.
                Wskaźnik ten nie jest powiązany ze sprawnością fizyczną, dlatego nie jest wykluczone, że zawodnik o niższym
                NTRP wygra z zawodnikiem o wyższym wskaźniku ze względu na kondycję oraz szybkość poruszania się po korcie.
            </p>

            <nav className={styles.toc} aria-label="Spis treści skali NTRP">
                <h3>Skocz do poziomu:</h3>
                <ul>
                    {LEVELS.map((lvl) => (
                        <li key={lvl.id}><a href={`#${lvl.id}`}>NTRP {lvl.level}</a></li>
                    ))}
                </ul>
            </nav>

            {LEVELS.map((lvl) => (
                <section key={lvl.id} id={lvl.id} className={styles.levelBlock}>
                    <h5>NTRP {lvl.level}</h5>
                    <p>{lvl.description}</p>
                    {(lvl.strengths || lvl.weaknesses) && (
                        <table className={styles.strengthWeakTable}>
                            <thead>
                                <tr>
                                    {lvl.strengths && <th>Mocne strony</th>}
                                    {lvl.weaknesses && <th>Słabości</th>}
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    {lvl.strengths && <td data-label="Mocne strony">{lvl.strengths}</td>}
                                    {lvl.weaknesses && <td data-label="Słabości">{lvl.weaknesses}</td>}
                                </tr>
                            </tbody>
                        </table>
                    )}
                </section>
            ))}
        </div>
    );
};

export default NtrpScale;
